import { Box, Typography } from "@mui/material";

import StyledButton from "default/components/StyledButton";

const parseTicketName = (name) => {
  const match = name?.match(/^(.*)（(\d+)日）$/);

  if (!match) {
    return {
      title: name,
      duration: null,
    };
  }

  return {
    title: match[1],
    durationDays: match[2],
  };
};

function TicketItem({ ticket, onClick }) {
  const { title, durationDays } = parseTicketName(ticket.name);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Typography
        sx={(theme) => ({
          mt: 1,
          textAlign: "center",
          letterSpacing: 0,
          ...theme.components.ticketBox.text.name,
        })}
      >
        {title}
      </Typography>

      {durationDays && (
        <Typography
          sx={(theme) => ({
            mt: 0.5,
            textAlign: "center",
            fontFamily: theme.system.fonts.body,
            fontSize: "20px",
            fontWeight: 700,
            letterSpacing: 0,
            color: "rgba(255, 255, 255, 0.78)",
          })}
        >
          <Box
            component="span"
            sx={(theme) => ({ color: theme.system.colors.red })}
          >
            {durationDays}
          </Box>
          日間
        </Typography>
      )}

      {ticket.description && (
        <Typography
          variant="h4"
          sx={(theme) => ({
            mt: 1.5,
            maxWidth: 320,
            textAlign: "center",
            lineHeight: 1.65,
            whiteSpace: "pre-line",
            letterSpacing: 0,
            ...theme.components.ticketBox.text.description,
          })}
        >
          {ticket.description}
        </Typography>
      )}

      <Typography
        variant="h4"
        sx={(theme) => ({
          mt: 2,
          fontSize: "1.7rem",
          fontWeight: 700,
          ...theme.components.ticketBox.text.price,
        })}
      >
        {ticket.displayPrice}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          mt: 1,
        }}
      >
        <StyledButton
          variant="contained"
          sx={{
            width: "48%",
            fontSize: "20px",
            fontWeight: "bold",
            mt: 1,
            mb: 1,
          }}
          onClick={() => onClick(ticket.ticket_key)}
        >
          BUY
        </StyledButton>

        {ticket.notice && (
          <Typography
            sx={(theme) => ({
              textAlign: "center",
              letterSpacing: 0,
              ...theme.components.ticketBox.text.notice,
            })}
          >
            {ticket.notice}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default TicketItem;
